import * as React from "react";
import { SVGProps, memo } from "react";
const SvgTable14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#BFBFBF"
        d="M5 4v2h3V4h1v2h3v1H9v2h3v1H9v2H8v-2H5v2H4v-2H1V9h3V7H1V6h3V4h1Zm3 3H5v2h3V7Z"
      />
      <path
        fill="#666"
        d="M12 0a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h11ZM1 4v8h11V4H1Zm0-1h11V1H1v2Z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgTable14Px);
export default Memo;
